import { getLang } from 'utils/query-params'
import { LanguagesEnum } from 'types/index'
import { determineInitialLanguage } from 'services/translations'

export const getLanguage = () => {
  const queryLang = getLang()
  const navigatorLanguage = determineInitialLanguage()

  return queryLang ? queryLang : (navigatorLanguage as LanguagesEnum)
}
